import { styled } from '@mui/material';

import { StyledFlexAllCenter } from 'shared/styles';

export const StyledIconCenter = styled(StyledFlexAllCenter)`
  transform: translate(0, 10%);
`;
